import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Form, InputNumber, Typography, Checkbox,
} from 'antd';
import './DetailsFields.scss';

const DetailsFields = (props) => {
  const {
    initialValuesObject, mode,
  } = props;

  const handleBrokenBoolean = (brokenValue) => {
    switch (true) {
      case (brokenValue === 'true'):
      case (brokenValue === true):
        return true;

      case (brokenValue === 'false'):
      case (brokenValue === false):
      default:
        return false;
    }
  };

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasFields__CropHeightRow"
      >
        <Col
          xs={{ span: 24 }}
          className="VantMapeamentoLinhasFields__CropHeightColumn"
        >
          <Form.Item
            label={(
              <Typography.Title
                level={5}
                className="VantMapeamentoLinhasFields__CropHeightTitle VantMapeamentoLinhasFields__AllFormLabels"
              >
                Inserir a altura da cultura (em m)
              </Typography.Title>
            )}
            name="VANT-MAPEAMENTO_LINHAS-INSERIR_ALTURA_CULTURA"
            className="VantMapeamentoLinhasFields__CropHeightFormItem"
            rules={[
              {
                required: true,
                message: 'Por favor informe a altura da cultura em metros',
              },
            ]}
            initialValue={initialValuesObject?.['VANT-MAPEAMENTO_LINHAS-INSERIR_ALTURA_CULTURA']}
          >
            <InputNumber
              className="VantMapeamentoLinhasFields__CropHeightInput"
              min={0.00}
              step={0.01}
              decimalSeparator=","
              disabled={mode === 'EDIT'}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasFields__PulverizationRow"
      >
        <Col
          xs={{ span: 24 }}
          className="VantMapeamentoLinhasFields__PulverizationColumn"
        >
          <Form.Item
            valuePropName="checked"
            name="VANT-MAPEAMENTO_LINHAS-PULVERIZACAO"
            className="VantMapeamentoLinhasFields__PulverizationFormItem"
            initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_LINHAS-PULVERIZACAO']) || false}
          >
            <Checkbox
              className="VantMapeamentoLinhasFields__PulverizationCheckbox VantMapeamentoLinhasFields__AllFormLabels"
              disabled={mode === 'EDIT'}
            >
              Pulverização
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasFields__SubsoilingRow"
      >
        <Col
          xs={{ span: 24 }}
          className="VantMapeamentoLinhasFields__SubsoilingColumn"
        >
          <Form.Item
            valuePropName="checked"
            name="VANT-MAPEAMENTO_LINHAS-SUBSOLAGEM"
            className="VantMapeamentoLinhasFields__SubsoilingFormItem"
            initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_LINHAS-SUBSOLAGEM']) || false}
          >
            <Checkbox
              className="VantMapeamentoLinhasFields__SubsoilingCheckbox VantMapeamentoLinhasFields__AllFormLabels"
              disabled={mode === 'EDIT'}
            >
              Subsolagem
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasFields__HarrowingRow"
      >
        <Col
          xs={{ span: 24 }}
          className="VantMapeamentoLinhasFields__HarrowingColumn"
        >
          <Form.Item
            valuePropName="checked"
            name="VANT-MAPEAMENTO_LINHAS-GRADAGEM"
            className="VantMapeamentoLinhasFields__HarrowingFormItem"
            initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_LINHAS-GRADAGEM']) || false}
          >
            <Checkbox
              className="VantMapeamentoLinhasFields__HarrowingCheckbox VantMapeamentoLinhasFields__AllFormLabels"
              disabled={mode === 'EDIT'}
            >
              Gradagem
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasFields__SecondaryCultureRow"
      >
        <Col
          xs={{ span: 24 }}
          className="VantMapeamentoLinhasFields__SecondaryCultureColumn"
        >
          <Form.Item
            valuePropName="checked"
            name="VANT-MAPEAMENTO_LINHAS-CULTURA_SECUNDARIA"
            className="VantMapeamentoLinhasFields__SecondaryCultureFormItem"
            initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_LINHAS-CULTURA_SECUNDARIA']) || false}
          >
            <Checkbox
              className="VantMapeamentoLinhasFields__SecondaryCultureCheckbox VantMapeamentoLinhasFields__AllFormLabels"
              disabled={mode === 'EDIT'}
            >
              Cultura Secundária
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasFields__TertiaryCultureRow"
      >
        <Col
          xs={{ span: 24 }}
          className="VantMapeamentoLinhasFields__TertiaryCultureColumn"
        >
          <Form.Item
            valuePropName="checked"
            name="VANT-MAPEAMENTO_LINHAS-CULTURA_TERCEARIA"
            className="VantMapeamentoLinhasFields__TertiaryCultureFormItem"
            initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_LINHAS-CULTURA_TERCEARIA']) || false}
          >
            <Checkbox
              className="VantMapeamentoLinhasFields__TertiaryCultureCheckbox VantMapeamentoLinhasFields__AllFormLabels"
              disabled={mode === 'EDIT'}
            >
              Cultura Terciária
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasFields__PlantingManeuverAutomationRow"
      >
        <Col
          xs={{ span: 24 }}
          className="VantMapeamentoLinhasFields__PlantingManeuverAutomationColumn"
        >
          <Form.Item
            valuePropName="checked"
            name="VANT-MAPEAMENTO_LINHAS-AUTOMATIZACAO_MANOBRA_PLANTIO"
            className="VantMapeamentoLinhasFields__PlantingManeuverAutomationFormItem"
            initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_LINHAS-AUTOMATIZACAO_MANOBRA_PLANTIO']) || false}
          >
            <Checkbox
              className="VantMapeamentoLinhasFields__PlantingManeuverAutomationCheckbox VantMapeamentoLinhasFields__AllFormLabels"
              disabled={mode === 'EDIT'}
            >
              Automatização de Manobra de Plantio (cereais)
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

DetailsFields.propTypes = {
  formInstance: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }).isRequired,

  initialValuesObject: PropTypes.shape({
    'VANT-MAPEAMENTO_LINHAS-INSERIR_ALTURA_CULTURA': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'VANT-MAPEAMENTO_LINHAS-PULVERIZACAO': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    'VANT-MAPEAMENTO_LINHAS-SUBSOLAGEM': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    'VANT-MAPEAMENTO_LINHAS-GRADAGEM': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    'VANT-MAPEAMENTO_LINHAS-CULTURA_SECUNDARIA': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    'VANT-MAPEAMENTO_LINHAS-CULTURA_TERCEARIA': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    'VANT-MAPEAMENTO_LINHAS-AUTOMATIZACAO_MANOBRA_PLANTIO': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }).isRequired,

  mode: PropTypes.oneOf(['CREATE', 'EDIT']).isRequired,
};
DetailsFields.defaultProps = {};

export default DetailsFields;
